// src/components/common/SensorSelector.js
import React from 'react';

const SensorSelector = ({ 
  availableSensors, 
  selectedSensors, 
  handleSensorChange,
  getSensorDisplayName
}) => {
  return (
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button className="accordion-button collapsed py-2" type="button" data-bs-toggle="collapse" data-bs-target="#sensorsCollapse">
          Sensori ({selectedSensors.length} selezionati)
        </button>
      </h2>
      <div id="sensorsCollapse" className="accordion-collapse collapse" data-bs-parent="#settingsAccordion">
        <div className="accordion-body py-2">
          <div className="d-flex flex-wrap gap-1 mb-2">
            {availableSensors.map(sensor => (
              <button
                key={sensor}
                onClick={() => handleSensorChange(sensor)}
                className={`btn btn-sm rounded-pill ${
                  selectedSensors.includes(sensor)
                    ? 'btn-primary'
                    : 'btn-outline-secondary'
                }`}
              >
                {getSensorDisplayName(sensor)}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SensorSelector;